import "./css/index.scss"

import $ from "./js/jquery"
import { setupCookiePolicy } from "./js/cookies"

import { setupContactForm } from "./js/contact-form"
import { setupTestOurStringsForm } from "./js/test-our-strings"

const setupMenu = () => {
  const breakpoint = 992
  const menu = $(".main-menu")
  const menu__lu = $(".main-menu lu")
  const menuToogle = $(".main-menu-toogle")
  const openClass = "opened"
  const vertical = $(".vertical-display")
  const menu__lu__lu = $(".main-menu lu>lu")

  const hideMenu = () => {
    menuToogle.removeClass(openClass).attr("aria-expaned", false)
    menu.slideUp()
  }
  const showMenu = () => {
    menuToogle.addClass(openClass).attr("aria-expaned", true)
    menu.slideDown()
  }

  const onResize = () => {
    if (window.innerWidth <= breakpoint) {
      hideMenu()
      menuToogle.slideDown()
    } else {
      showMenu()
      menuToogle.slideUp()
    }
  }

  menuToogle.on("click", function (e) {
    e.preventDefault()
    if (menuToogle.hasClass(openClass)) {
      hideMenu()
      menu__lu.removeClass(vertical) //not working
    } else {
      showMenu()
      menu__lu.addClass(vertical) //not working
    }
  })

  $(window).on("resize", (e) => {
    // onResize();
  })
  // on load
  onResize()
}

$(function () {
  // setupMenu()
  setupCookiePolicy(window.cookiesPageURL)
  setupContactForm()
  setupTestOurStringsForm()
})
